import React from 'react'
import Cleave from 'cleave.js/react'
function InputNumber({ value, onChange, className, maxLength, ...other }) {
  const options = {
    uppercase: true
  }
  const regex = /^[A-Za-z0-9]+$/

  return (
    <Cleave
      maxLength={10}
      className={`form-control ${className}`}
      value={value}
      onChange={(e) => {
        if (e.target.value) {
          if (e.target.value.match(regex)) {
            onChange(e)
          }
        }
      }}
      options={options}
      id="prefix"
      {...other}
    />
  )
}

export default InputNumber
